var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.2456 3H8.7456C8.0152 3 7.32 3.28663 6.8008 3.7904C6.2816 4.30286 6 4.98903 6 5.70994V76.2814C6 77.2802 6.5544 78.2009 7.452 78.6699C8.3496 79.1477 9.432 79.0869 10.2768 78.5397L17 74.1099L23.7232 78.5397C24.6472 79.1477 25.8528 79.1477 26.7768 78.5397L33.5 74.1099L40.2232 78.5397C41.1472 79.1477 42.3528 79.1477 43.2768 78.5397L50 74.1099L56.7232 78.5397C57.568 79.0955 58.6504 79.1477 59.548 78.6699C60.4456 78.2009 61 77.2802 61 76.2814V5.70994C61 4.98903 60.7096 4.30286 60.1992 3.7904C59.68 3.28663 58.976 3 58.2456 3ZM22.5 19.2857H39C40.5224 19.2857 41.7456 20.5017 41.7456 21.9957C41.7456 23.4896 40.5136 24.7056 39 24.7056H22.5C20.9776 24.7056 19.7544 23.4896 19.7544 21.9957C19.7544 20.5017 20.9864 19.2857 22.5 19.2857ZM41.7544 51.8571H22.5C20.9776 51.8571 19.7544 50.6411 19.7544 49.1472C19.7544 47.6533 20.9864 46.4373 22.5 46.4373H41.7544C43.2768 46.4373 44.5 47.6533 44.5 49.1472C44.5 50.6411 43.268 51.8571 41.7544 51.8571ZM47.2544 38.2901H22.5088C20.9864 38.2901 19.7632 37.0741 19.7632 35.5801C19.7632 34.0862 20.9952 32.8702 22.5088 32.8702H47.2544C48.7768 32.8702 50 34.0862 50 35.5801C50 37.0741 48.768 38.2901 47.2544 38.2901Z",
    fill: "#00A100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.15bf968d7ae5bac12d01a04569aa395a.svg";
export { ForwardRef as ReactComponent };